// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getYear as fn } from "../getYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getYear;
